import { lazy, Suspense } from "react";
import { Layout } from "@/components/layout/Layout";
import { HeroSection } from "@/components/home/HeroSection";
import { JsonLd } from "@/components/seo/JsonLd";

// Lazy load below-fold sections to improve TTI
const ServicesSection = lazy(() => import("@/components/home/ServicesSection").then(m => ({ default: m.ServicesSection })));
const FeaturedVideosSection = lazy(() => import("@/components/home/FeaturedVideosSection").then(m => ({ default: m.FeaturedVideosSection })));
const VerticalVideosSection = lazy(() => import("@/components/home/VerticalVideosSection").then(m => ({ default: m.VerticalVideosSection })));
const PackageRecommender = lazy(() => import("@/components/PackageRecommender").then(m => ({ default: m.PackageRecommender })));
const TestimonialsSection = lazy(() => import("@/components/home/TestimonialsSection").then(m => ({ default: m.TestimonialsSection })));
const MailingListSection = lazy(() => import("@/components/home/MailingListSection").then(m => ({ default: m.MailingListSection })));
const CTASection = lazy(() => import("@/components/home/CTASection").then(m => ({ default: m.CTASection })));

// Minimal skeleton for lazy sections
const SectionSkeleton = () => (
  <div className="py-16 flex items-center justify-center">
    <div className="w-8 h-8 border-2 border-primary border-t-transparent rounded-full animate-spin" />
  </div>
);

const Index = () => {
  return (
    <Layout hasHero>
      <JsonLd />
      <HeroSection />
      <Suspense fallback={<SectionSkeleton />}>
        <ServicesSection />
      </Suspense>
      <Suspense fallback={<SectionSkeleton />}>
        <FeaturedVideosSection />
      </Suspense>
      <Suspense fallback={<SectionSkeleton />}>
        <VerticalVideosSection />
      </Suspense>
      <Suspense fallback={<SectionSkeleton />}>
        <PackageRecommender />
      </Suspense>
      <Suspense fallback={<SectionSkeleton />}>
        <TestimonialsSection />
      </Suspense>
      <Suspense fallback={<SectionSkeleton />}>
        <MailingListSection />
      </Suspense>
      <Suspense fallback={<SectionSkeleton />}>
        <CTASection />
      </Suspense>
    </Layout>
  );
};

export default Index;
